var _HashGenerator_index;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import md5 from 'md5';
export class HashGenerator {
    constructor() {
        _HashGenerator_index.set(this, 0);
    }
    generate(salt = 'default-salt') {
        var _a, _b;
        const timestamp = new Date().getTime();
        const salted = timestamp + salt + (__classPrivateFieldSet(this, _HashGenerator_index, (_b = __classPrivateFieldGet(this, _HashGenerator_index, "f"), _a = _b++, _b), "f"), _a);
        return md5(salted);
    }
}
_HashGenerator_index = new WeakMap();
